import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
};

const debitNotesSlice = createSlice({
  name: 'debitNotes',
  initialState,
  reducers: {
    cancelDebitNoteRequest(state) {
      state.loading = true;
      state.error = null;
    },
    cancelDebitNoteSuccess(state) {
      state.loading = false;
      state.error = null;
      state.isDebitNoteCancelled = true;
    },
    cancelDebitNoteFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { cancelDebitNoteRequest, cancelDebitNoteSuccess, cancelDebitNoteFailure } = debitNotesSlice.actions;

export default debitNotesSlice.reducer;
